import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { Box, Dialog, DialogContent, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useSelector } from 'react-redux';

import FuelDialogHeader from '../../../components/fuel-dialog-header/fuel-dialog-header';
import { assetEditorSelector } from '../../../store/slices/asset-editor';
import clientUtils from '../../../utils/clientUtils';

interface IProps {
  open: boolean;
  onClose: () => void;
  deleteFile: (file, key) => void;
}
const IngestFileListDialog = ({ open, onClose, deleteFile }: IProps) => {
  const { assetForm } = useSelector(assetEditorSelector);

  return (
    <Dialog open={open} sx={{ marginLeft: '75px' }} id="upload-dialog">
      <FuelDialogHeader onClose={() => onClose()}>Selected files ({assetForm.ingestFiles.length})</FuelDialogHeader>
      <DialogContent dividers sx={{ padding: '0px 0px !important', width: '450px' }}>
        <Box role="presentation">
          <List>
            {assetForm.ingestFiles.map((file, key) => (
              <ListItem key={key} disablePadding sx={{ borderBottom: '1px solid #ddd' }}>
                <ListItemButton>
                  <ListItemIcon>
                    <VideoFileIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={clientUtils.shortenFileName(file?.name, 32)}
                    secondary={clientUtils.calcSize(file.size)}
                  />
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {/* <Box sx={{ width: '100%', mr: 1 }}> {clientUtils.calcSize(file.size)}</Box> */}
                      <Box>
                        <DeleteForeverIcon titleAccess="Delete" onClick={(e) => deleteFile(file, key)} />
                      </Box>
                    </Box>
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default IngestFileListDialog;
